import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "card"
}
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "list-group list-group-flush" }
const _hoisted_6 = {
  class: "text-primary",
  target: "_blank"
}
const _hoisted_7 = {
  key: 1,
  class: "card mt-3"
}
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "list-group list-group-flush" }
const _hoisted_10 = {
  class: "text-primary",
  target: "_blank"
}
const _hoisted_11 = {
  key: 2,
  class: "card mt-3"
}
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "list-group list-group-flush" }

import { computed, toRef } from 'vue'
    import { useRoute } from 'vue-router'

    import { dynamicUiRoutes } from '@common/dynamicUiRoutes'

    import type { FormDefDependenciesReadModel } from '@Alternatives/Forms/Domain/readmodels'
    import type { DependentEntityInfo } from '@common/types'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FormDependenciesList',
  props: {
    readModel: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- router ----------------

    const route = useRoute()

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'readModel')

    // ---------------- computed ----------------

    const requestPages = computed<DependentEntityInfo[]>(() =>
        rm.value?.RequestPages ?? []
    )

    // ---------------- url helpers ----------------

    function url_EditRequestPagePage(e: DependentEntityInfo): string
    {
        return dynamicUiRoutes.Pages_EditRequestPagePage(
            route,
            e.WorkspaceId,
            e.TchProjectId,
            Number.parseInt(e.Id)
        )
    }

    function url_ReportViewPage(e: DependentEntityInfo): string
    {
        return dynamicUiRoutes.Reports_ReportViewPage(
            route,
            e.WorkspaceId,
            e.TchProjectId,
            e.Id
        )
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!rm.value)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
          _createTextVNode(" Checking dependencies... ", -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    (rm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (requestPages.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, " RequestPages (" + _toDisplayString(requestPages.value.length) + ") ", 1 /* TEXT */),
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requestPages.value, (p) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "list-group-item",
                      key: p.Id
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [
                        _createTextVNode(_toDisplayString(p.Name), 1 /* TEXT */)
                      ])), [
                        [_directive_sanitizedHref, url_EditRequestPagePage(p)]
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (rm.value.Reports.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, " Reports (" + _toDisplayString(rm.value.Reports.length) + ") ", 1 /* TEXT */),
                _createElementVNode("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Reports, (r) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "list-group-item",
                      key: r.Id
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, [
                        _createTextVNode(_toDisplayString(r.Name), 1 /* TEXT */)
                      ])), [
                        [_directive_sanitizedHref, url_ReportViewPage(r)]
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (rm.value.Notifications.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, " Notifications (" + _toDisplayString(rm.value.Notifications.length) + ") ", 1 /* TEXT */),
                _createElementVNode("ul", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Notifications, (n) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "list-group-item",
                      key: n.Id
                    }, [
                      _createElementVNode("span", null, _toDisplayString(n.Name), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})